import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import React, { lazy, Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const Loadable = (Component) => (props) => {
    return (
        <Suspense>
            <Component {...props} />
        </Suspense>
    );
};

const Spinner = Loadable(lazy(() => import("../component/Spinner")));
const Login = Loadable(lazy(() => import("../pages/auth/Login")));

const PageNotFound = Loadable(lazy(() => import("./PageNotFound")));

const ForgotPassword = Loadable(lazy(() => import("../pages/auth/ForgotPassword")));

const MangeCustomer = Loadable(lazy(() => import("../pages/ManageCustomer")));
const ViewCustomerDetials = Loadable(lazy(() => import("../pages/ManageCustomer/ViewCustomer")));
const ManageContractor = Loadable(lazy(() => import("../pages/ManageContractor/index.js")));
const ViewContractor = Loadable(lazy(() => import("../pages/ManageContractor/ViewContractor.js")));

const ManageBanner = Loadable(lazy(() => import("../pages/ManageBanner/index.js")));
const AddBanner = Loadable(lazy(() => import("../pages/ManageBanner/AddBanner.js")));

const Dashboard = Loadable(lazy(() => import("../pages/Dashbord/Index")));
const MyProfile = Loadable(lazy(() => import("../pages/MyProfile")));

const ChangePassword = Loadable(lazy(() => import("../pages/MyProfile/ChangePassword")));

const AboutUs = Loadable(lazy(() => import("../pages/AppContent")));
const ContactUs = Loadable(lazy(() => import("../pages/ContectUs")));


const ManageSubscription = Loadable(lazy(() => import("../pages/ManageSubscription/index.js")));
const AddSubscription = Loadable(lazy(() => import("../pages/ManageSubscription/addSubsription.js")));

const ManageNotification = Loadable(lazy(() => import("../pages/ManageNotification/notification_index.js")));


const AddNotification = Loadable(lazy(() => import("../pages/ManageNotification/Addnotification.js")));


const ManagePrice = Loadable(lazy(() => import("../pages/ManagePrice/PriceIndex.js")));
const AddPrice = Loadable(lazy(() => import("../pages/ManagePrice/AddPrice.js")));


const RepairManagePrice = Loadable(lazy(() => import("../pages/ManagePrice/PriceSettingRepair/RepairIndex.js")));
const RepairAddPrice = Loadable(lazy(() => import("../pages/ManagePrice/PriceSettingRepair/RepairAddprice.js")));

const FAQ = Loadable(lazy(() => import("../pages/ManageFaq/index.js")));
const AddFaq = Loadable(lazy(() => import("../pages/ManageFaq/AddFaq.js")));
const ViewFaq = Loadable(lazy(() => import("../pages/ManageFaq/ViewFaq.js")));


const ViewAllNotication = Loadable(lazy(() => import("../pages/Notification/index.js")));

const Router = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { isLoading } = useSelector((state) => state.masterslice);

    let islogin = localStorage.getItem("PisLogin");
    const token = localStorage.getItem("Ptoken");

    useEffect(() => {
        if (!islogin) {
            navigate('/');
        } else if (islogin && (location?.pathname == '/dashboard' || location?.pathname == '/')) {
            navigate('/');
        }
    }, [islogin, token]);


    if (!islogin) {
        return (
            <>
                <Spinner isActive={isLoading} message={'Please Wait...'} />
                <Routes>

                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />

                </Routes>
            </>)
    } else {
        return (
            <>
                <Spinner isActive={isLoading} message={'Please Wait...'} />
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />

                    <Route path="/customer_list" element={<MangeCustomer />} />
                    <Route path="/customer_list/customer_details" element={<ViewCustomerDetials />} />
                 

                    <Route path="/contractor_list" element={<ManageContractor />} />
                    <Route path="/contractor_list/contractor_list_details" element={<ViewContractor />} />
                    <Route path="/banner_list" element={<ManageBanner />} />
                    <Route path="/add_category" element={<AddBanner />} />
                 


                    <Route path="/subscription_list" element={<ManageSubscription />} />
                    <Route path="/add_subscription" element={<AddSubscription />} />

                    <Route path="/notification_list" element={<ManageNotification />} />
                    <Route path="/add_notification" element={<AddNotification />} />
                    
                    <Route path="/my_profile" element={<MyProfile />} />
                    <Route path="/change_password" element={<ChangePassword />} />
                    <Route path="/forget_password" element={<ForgotPassword />} />
                    <Route path="/contact_us" element={<ContactUs />} />

                    <Route path='/about-us' element={<AboutUs />} />
                    <Route path='/privacy-policy' element={<AboutUs />} />
                    <Route path='/terms-condition' element={<AboutUs />} />

                    <Route path='/subscriptions' element={<AboutUs />} />
                    
                    <Route path='/faq' element={<FAQ />} />
                    <Route path='/add_faq' element={<AddFaq />} />
                    <Route path='/view_faq' element={<ViewFaq />} />
                 
                    <Route path='/View_all_notication' element={<ViewAllNotication />} />


                    {/* AddPrice */}
                    <Route path="/price_setting_list" element={<ManagePrice />} />
                    <Route path="/add_price_setting" element={<AddPrice />} />

                    <Route path="/repair_price_setting_list" element={<RepairManagePrice />} />
                    <Route path="/repair_add_price_setting" element={<RepairAddPrice />} />
                    
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </>
        )
    }

}

export default Router;
